module.exports = __webpack_public_path__ + "img/registrantImg.45507793.png";